import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    access_time: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    nights_stay: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.69 4.27 1.8.48.5.85 1.1 1.1 1.77.07.19.11.39.11.61 0 .2-.03.4-.08.59-.01.06-.02.13-.04.19C10.15 16.17 10.8 16 11.5 16c1.61 0 3.09.59 4.23 1.57C14.03 16.2 12.65 14.24 11.1 12.08z"/>
      </svg>
    ),
    wb_sunny: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"/>
      </svg>
    ),
    weekend: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zM5.5 2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.83 4 7 4 5.5 3.33 5.5 2.5zm11 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.83 4 18 4s-1.5-.67-1.5-1.5zM12.5 7h-1V6h1v1zm0 2h-1V8h1v1z"/>
      </svg>
    ),
    business_center: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 7V5h4v2h-4z"/>
      </svg>
    ),
    support: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"/>
        <circle cx="9" cy="13" r="1"/>
        <circle cx="15" cy="13" r="1"/>
        <path d="M18 11.03C17.52 8.18 15.04 6 12.05 6c-3.03 0-6.29 2.51-6.03 6.45 2.47-1.01 4.33-3.21 4.86-5.89 1.31 2.63 4 4.44 7.12 4.47z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    public: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const TwentyFourSevenPhoneAnswering = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "After Hours Inquiry",
      time: "Sunday, 11:30 PM",
      customer: "Hi, I know you're probably closed but I'm having an emergency with my heating system. Can someone help?",
      response: "I'm here to help! Even though it's late, I can connect you with our emergency heating technician. They can be at your home within 2 hours to fix your heating issue.",
      outcome: "$350 emergency service",
      color: "blue"
    },
    {
      type: "Holiday Booking",
      time: "Christmas Day, 2:15 PM", 
      customer: "I need to book a cleaning service for next week. Are you open today to schedule?",
      response: "Absolutely! I'm available 24/7 to help with scheduling. I can book your cleaning service for next Tuesday at 10 AM. You'll receive confirmation details shortly.",
      outcome: "$180 cleaning booked",
      color: "blue"
    },
    {
      type: "Weekend Lead",
      time: "Saturday, 7:45 AM",
      customer: "I'm interested in your landscaping services. Do you work on weekends or should I call back Monday?",
      response: "Perfect timing! I can schedule your landscaping consultation for this Saturday at 3 PM. Our weekend team will assess your yard and provide a detailed estimate.",
      outcome: "$2,800 landscaping lead",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "We capture business around the clock now. Weekend and evening calls that used to go to voicemail are now converted into paying customers.",
      author: "Carlos M.",
      business: "24/7 Emergency Services",
      result: "40% more weekend revenue"
    },
    {
      quote: "The AI never sleeps, never takes breaks, and treats every caller professionally no matter what time they call. Our availability is now our biggest competitive advantage.",
      author: "Lisa K.",
      business: "Premier Home Services",
      result: "24/7 competitive edge"
    },
    {
      quote: "Holiday calls, late night emergencies, early morning inquiries - we capture every opportunity. Our business has grown 160% since implementing 24/7 AI.",
      author: "Robert T.",
      business: "Elite Property Management",
      result: "160% business growth"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "24/7 Phone Answering Service - AI That Never Sleeps",
    "description": "AI phone answering service available 24 hours a day, 7 days a week. Never miss calls on weekends, holidays, or after hours. Perfect professional service anytime.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="24/7 Phone Answering Service | AI That Never Sleeps or Takes Breaks"
        description="24/7 AI phone answering service captures calls anytime - weekends, holidays, after hours. Never miss business opportunities with always-available professional service."
        keywords="24/7 phone answering service, after hours phone service, weekend phone answering, holiday phone service, 24 hour receptionist, never miss calls, always available"
        canonical="https://receptioneer.ai/24-7-phone-answering"
        ogTitle="24/7 Phone Answering Service - AI That Never Sleeps"
        ogDescription="Never miss another call. AI phone service available 24 hours a day, 7 days a week. Professional service on weekends, holidays, and after hours."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-purple-900 via-purple-800 to-purple-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-purple-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🕐 24/7 Phone Service
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another Call
                <br />
                <span className="text-purple-200">Day or Night</span>
              </h1>
              
              <p className="text-xl text-purple-100 mb-8 leading-relaxed">
                Your AI receptionist answers every call 24 hours a day, 7 days a week. Weekends, holidays, 3 AM emergencies - we're always here.
                <strong className="text-white"> Professional service that never sleeps.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-purple-900 hover:bg-purple-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get 24/7 Phone Service →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-purple-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Anytime Availability
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-purple-200 text-sm">Always Available</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">365</div>
                  <div className="text-purple-200 text-sm">Days Per Year</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">0</div>
                  <div className="text-purple-200 text-sm">Missed Calls</div>
                </div>
              </div>
            </div>

            <div className="bg-purple-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-purple-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Customer:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className="rounded-lg p-3 bg-purple-50">
                    <div className="text-xs font-semibold mb-1 text-purple-600">AI Available 24/7:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-purple-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Captured anytime</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-purple-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 24/7 Coverage */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Complete <span className="text-purple-600">24/7 Coverage</span>
            </h2>
            
            <div className="grid lg:grid-cols-4 gap-6">
              <div className="bg-blue-50 rounded-3xl p-6 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
                  <MaterialIcon name="wb_sunny" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-black mb-2 text-gray-900">Business Hours</h3>
                <p className="text-gray-700 text-sm">Professional service during your normal operating hours with perfect consistency.</p>
              </div>

              <div className="bg-purple-50 rounded-3xl p-6 text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
                  <MaterialIcon name="nights_stay" className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-lg font-black mb-2 text-gray-900">After Hours</h3>
                <p className="text-gray-700 text-sm">Capture late night calls and emergencies when competitors are closed.</p>
              </div>

              <div className="bg-green-50 rounded-3xl p-6 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
                  <MaterialIcon name="weekend" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-lg font-black mb-2 text-gray-900">Weekends</h3>
                <p className="text-gray-700 text-sm">Saturday and Sunday calls turned into revenue while others miss opportunities.</p>
              </div>

              <div className="bg-red-50 rounded-3xl p-6 text-center">
                <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
                  <MaterialIcon name="public" className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-lg font-black mb-2 text-gray-900">Holidays</h3>
                <p className="text-gray-700 text-sm">Christmas, New Year, Thanksgiving - we're working when everyone else is off.</p>
              </div>
            </div>
          </div>
        </section>

        {/* The Cost of Missing Calls */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              The Hidden Cost of <span className="text-red-600">Missed Calls</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <h3 className="text-2xl font-black mb-6 text-gray-900 flex items-center gap-3">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-600" />
                  When You're Closed
                </h3>
                
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Emergency calls</strong> go to competitors who are available</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Weekend projects</strong> get booked with available businesses</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Holiday opportunities</strong> are lost to voicemail</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>International customers</strong> in different time zones can't reach you</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Urgent inquiries</strong> become cold leads by Monday</span>
                  </li>
                </ul>

                <div className="mt-6 p-4 bg-red-50 rounded-xl">
                  <div className="text-red-800 font-bold">Average Business Loses:</div>
                  <div className="text-2xl font-black text-red-900">$2,400/month</div>
                  <div className="text-red-700 text-sm">in missed after-hours opportunities</div>
                </div>
              </div>

              <div className="bg-purple-50 rounded-3xl p-8">
                <h3 className="text-2xl font-black mb-6 text-gray-900 flex items-center gap-3">
                  <MaterialIcon name="checkCircle" className="w-8 h-8 text-purple-600" />
                  With 24/7 AI Service
                </h3>
                
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" />
                    <span><strong>Emergency services</strong> booked immediately, any time</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" />
                    <span><strong>Weekend consultations</strong> scheduled while customers are motivated</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" />
                    <span><strong>Holiday planning calls</strong> converted to appointments</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" />
                    <span><strong>Global customers</strong> served in any time zone</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-purple-600 flex-shrink-0 mt-1" />
                    <span><strong>Hot leads</strong> captured while they're still motivated</span>
                  </li>
                </ul>

                <div className="mt-6 p-4 bg-purple-100 rounded-xl">
                  <div className="text-purple-800 font-bold">Businesses Report Gaining:</div>
                  <div className="text-2xl font-black text-purple-900">$3,800/month</div>
                  <div className="text-purple-700 text-sm">in new after-hours revenue</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industries That Need 24/7 */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Who Needs <span className="text-purple-600">24/7 Service</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-purple-50 rounded-2xl p-6">
                  <MaterialIcon name="support" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Emergency Services</h3>
                    <p className="text-gray-700 text-sm">Plumbers, electricians, HVAC, locksmiths, and restoration services need 24/7 availability.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-blue-50 rounded-2xl p-6">
                  <MaterialIcon name="business_center" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Professional Services</h3>
                    <p className="text-gray-700 text-sm">Lawyers, consultants, accountants serving clients across time zones and busy schedules.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-green-50 rounded-2xl p-6">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Sales & Marketing</h3>
                    <p className="text-gray-700 text-sm">Real estate, insurance, solar, and high-ticket sales that can't afford missed opportunities.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-yellow-50 rounded-2xl p-6">
                  <MaterialIcon name="access_time" className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Healthcare & Wellness</h3>
                    <p className="text-gray-700 text-sm">Medical practices, dental offices, urgent care, and mental health services.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-red-50 rounded-2xl p-6">
                  <MaterialIcon name="public" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Global Businesses</h3>
                    <p className="text-gray-700 text-sm">Companies serving international markets across multiple time zones.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-indigo-50 rounded-2xl p-6">
                  <MaterialIcon name="weekend" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Consumer Services</h3>
                    <p className="text-gray-700 text-sm">Home services, cleaning, landscaping, and services customers need on weekends.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Businesses Love <span className="text-purple-600">24/7 Availability</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="access_time" className="w-8 h-8 text-purple-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-purple-50 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-purple-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Always-On Pricing */}
        <section className="py-16 px-6 bg-purple-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Never Sleep, Never Miss Revenue
            </h2>
            
            <p className="text-xl text-purple-100 mb-8">
              While your competitors sleep, you're capturing customers. 24/7 availability gives you an unfair advantage.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-purple-100 mb-6">per month • 24/7/365 • unlimited calls</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-purple-900 hover:bg-purple-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get 24/7 Phone Service →
              </button>
            </div>
            
            <p className="text-purple-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your 24/7 Phone Service"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your 24/7 phone service ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  placeholder="e.g. Carlos Martinez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  placeholder="carlos@247services.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-purple-900 hover:bg-purple-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My 24/7 Phone Service'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/24-7-phone-answering" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default TwentyFourSevenPhoneAnswering;